import * as Sentry from '@sentry/nextjs';
import { setUserContext } from '../../lib/api/user-context/userContextApi';
import type { UserContext } from '../../lib/api/user-context/user-context';

// Exported so it can be called explicitly after login.
export async function setSentryUser(providedContext?: UserContext) {
  try {
    if (providedContext) {
      Sentry.setUser({
        username: providedContext.username,
        id: providedContext.userId,
        ...(providedContext.exhibitorId && { exhibitorId: providedContext.exhibitorId }),
        ...(providedContext.eventEditionId !== undefined && { eventEditionId: String(providedContext.eventEditionId) }),
      });
      return;
    }

    const result = await setUserContext();

    if (result.ok) {
      const userContext = result.value;
      // Set in Sentry
      Sentry.setUser({
        username: userContext.username,
        id: userContext.userId,
        ...(userContext.exhibitorId && { exhibitorId: userContext.exhibitorId }),
        ...(userContext.eventEditionId !== undefined && { eventEditionId: String(userContext.eventEditionId) }),
      });
    } else {
      // User not logged in or not authenticated, clear Sentry user
      Sentry.setUser(null);
    }
  } catch (error) {
    // Silently fail - don't break Sentry if API call fails
    console.debug('[Sentry] Failed to fetch user info:', error);
    Sentry.setUser(null);
  }
}
